module.exports = __webpack_public_path__ + "static/media/mana-sphere.603ade52.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mana-sphere.gif
// module id = 125
// module chunks = 48